// 为安装步骤补齐运行时 UI 状态字段。
export function createInstallSteps(steps: any[] = []): any[] {
    return steps.map((step) => ({
        ...step,
        currentIcon: step.icon,
        detailText: '',
        status: 'pending',
    }));
}
